<template>
    <div class="row">
        <!-- <div class="col-2"> -->
        <!-- <div class="app-sidebar">
            <SidebarToggler class="d-lg-none" display="md" mobile />
            <sidebaradvance ></sidebaradvance>
        </div> -->
    <!-- </div> -->
        <div id="app1" :class="sidebarClass" class="col-lg-2 col-md-0 col-sm-0 p-0">
            <AppSidebar ref="sidebar" id="sidebar" class="overflow-auto d-md-down-none" display="lg" >
              <sidebaradvance />
          </AppSidebar>

          <AppSidebar ref="sidebar" id="sidebarmobile" class="overflow-auto d-lg-none" display="md" mobile>
            <sidebaradvance />
          </AppSidebar>
        </div>
        
        <div id="appBody" :class="appBodyClass" class="col-lg-10 col-md-12 col-sm-12 p-0">
          
            <div>
                <AppHeader class="nav" fixed style="width:100%" >
                    <SidebarToggler class="d-lg-none" display="md" mobile @click.native="toggleMobileSidebar" />
                    <SidebarToggler class="d-md-down-none" display="lg" :defaultOpen=true @click.native="toggleSidebar"/>
                
                <!-- <SidebarToggler :defaultOpen=true /> &nbsp;&nbsp; -->
                <!-- <SidebarToggler :defaultOpen="true" class="d-none d-lg-block" @click="toggleSidebar"/> -->

                <b-navbar-nav v-if="isQuickDashboard">
                <b-nav-item class="px-3 d-sm-down-none" to="/adminuser_mr/quick_dashboard" v-if="this.id === 29 || (this.id === 17 && userCountry == 'KSA') || (this.id === 14)  || (this.id === 19 && userCountry == 'ME')|| (this.id === 35 && userCountry == 'ME') || (this.id === 30 && userCountry == 'ME') || (this.id === 44 && userCountry == 'ME') || (this.id === 61 && userCountry == 'ME') || (this.id === 66 && userCountry == 'ME') || (this.id === 67 && userCountry == 'ME') || (this.id === 68 && userCountry == 'ME') || (this.id === 124 && userCountry == 'ME') || (this.id === 57 && userCountry == 'KSA')">Admin user </b-nav-item>
                
                </b-navbar-nav>
                <b-navbar-nav v-else>
                <b-nav-item class="px-3 d-sm-down-none" to="/adminuser_mr/normal" v-if="this.id === 29 || (this.id === 17 && userCountry == 'KSA') || (this.id === 14)  || (this.id === 19 && userCountry == 'ME')|| (this.id === 35 && userCountry == 'ME') || (this.id === 30 && userCountry == 'ME') || (this.id === 44 && userCountry == 'ME') || (this.id === 61 && userCountry == 'ME') || (this.id === 66 && userCountry == 'ME') || (this.id === 67 && userCountry == 'ME') || (this.id === 68 && userCountry == 'ME') || (this.id === 124 && userCountry == 'ME') || (this.id === 57 && userCountry == 'KSA')">Admin user </b-nav-item>
                
                </b-navbar-nav>
                
                <b-link class="navbar-brand d-sm-down-none" to="/dashboard_mr" >
                {{userCountry=='KSA'?'Firstcry Logistic - KSA':'Firstcry Logistic - ME'}}
                </b-link>   

                <b-navbar-nav class="ml-auto">
                    <span class="d-flex flex-flow mr-2" v-if="userCountry=='KSA' && isB2B">

                      <!-- P2P -->
                      <button 
                        class="btn"
                        :class="!isQuickDashboard ? 'btn-primary' : ''"
                        @click="goTop2pDashboard"
                      >
                        P2P
                      </button> 

                      <!-- B2B -->
                      <button 
                        class="btn" 
                        @click="goToB2BDashboard"
                      >
                        B2B
                      </button>
                     </span>
                      <span v-if="this.issuperadmin == 1">
                      <!-- QUICK -->
                      <button
                        class="btn"
                        :class="$route.params.id === 'quick_dashboard' ? 'btn-primary' : ''"
                        @click="goToQuickDashboard"
                      >
                        QUICK
                      </button>
                    </span>
                    

                    <span class="d-flex flex-flow mr-2" v-if="userCountry=='ME' && isquick == 'no'">

                      <!-- P2P -->
                      <button 
                        class="btn"
                        :class="!isQuickDashboard ? 'btn-primary' : ''"
                        @click="goTop2pDashboard"
                      >
                        P2P
                      </button> 
                     </span>

                      <span v-if="userCountry=='ME' && isquick == 'no'">
                      <!-- QUICK -->
                      <button
                        class="btn"
                        :class="$route.params.id === 'quick_dashboard' ? 'btn-primary' : ''"
                        @click="goToQuickDashboard"
                      >
                        QUICK
                      </button>
                    </span>


                    <DefaultHeaderDropdownAccnt/>
                </b-navbar-nav>
                <AsideToggler class="d-none d-lg-none" />
            
                </AppHeader>
            </div>
            <div class="app-body" style="width:101%;">
      
                <main class="main" style="padding-right:0px">
                
                    <div class="container-fluid p-0">
                    <router-view></router-view>          
                    </div>
                    <div id="overlay" style="display: none;">
                    <div class="loader"></div>
                    <br/>
                    <span class="loading" style="color:#fff;">Loading...</span>
                </div>
                </main>
                
            </div>
            
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import sidebaradvance from '@/components/sidebaradvance'


import { Header as AppHeader, SidebarToggler, Sidebar as AppSidebar, SidebarFooter, SidebarForm, SidebarHeader, SidebarMinimizer, SidebarNav, Aside as AppAside, AsideToggler, Footer as TheFooter, Breadcrumb } from '@coreui/vue'
import DefaultAside from './DefaultAside'
import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt'

export default {
  name: 'DefaultContainer',
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    DefaultAside,
    DefaultHeaderDropdownAccnt,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    sidebaradvance,
    SidebarNav,
    SidebarMinimizer,
    issuperadmin:'',
  },
  data () {
  
    return {
      id:'',
      // Auto Logout Start
            events:['click','dblclick','mousemove','mouseup','mousedown','drag','scroll','keyup','keydown','keypress','load'],
             // warningTimer:null,
            logoutTimer:null,
            // Auto Logout End
            sidebarOpen: true,
            isB2B:false,
            quickdashbaordid:''
     
    }
  },
  created() {  
      this.quickdashbaordid = this.$route.params.id;
    // localStorage.clear();
    this.getuserdetails();   
  },
   // Auto Logout Start
      mounted(){
        this.events.forEach(function(event){
          window.addEventListener(event,this.resetTimer);
        },this);
        // this.setTimer();
        document.addEventListener('click', this.handleClickOutside);
      },
      destroyed(){
         this.events.forEach(function(event){
          window.removeEventListener(event,this.resetTimer);
        },this);
        // this.resetTimer();
        document.removeEventListener('click', this.handleClickOutside);
      },
      // Auto Logout End
  computed: {
    name () {
      return this.$route.name
    },
    list () {
      return this.$route.matched.filter((route) => route.name || route.meta.label )
    },

    sidebarClass() {
      return this.sidebarOpen ? 'col-lg-2' : 'col-lg-0';
    },
    appBodyClass() {
      return this.sidebarOpen ? 'col-lg-10' : 'col-lg-12';
    },
    isQuickDashboard() {
      return this.$route.params.id === 'quick_dashboard' ||
      this.$route.query.is_qwik_user === 'yes';
    }

  },
  methods: {
    handleClickOutside(event) {
        const sidebar = this.$refs.sidebar.$el;
        if (!sidebar.contains(event.target)) {
           // console.log('clicked outside');
            document.getElementById("sidebarmobile").style.display = 'none';
        }
    },

    toggleSidebar() {
      this.sidebarOpen = !this.sidebarOpen;   
    },

    toggleMobileSidebar:function(){
        //console.log("toggle bar")
        document.getElementById("sidebarmobile").style.display='block'
    },

           logoutUser: function() {
            // alert('logout');
            localStorage.setItem('userData', '')
            this.$router.push('/login').catch(()=>{});
             // window.location.href ="/p2p_cms/login";
              // window.location.hash = "#reloaded";
            //document.getElementById('login-form').submit();
          },

          // Auto Logout End
    getuserdetails: function() {
      var userData = localStorage.getItem('userData')
      // console.log("lllllllllllllllll",userData);
      if (userData) {
        var userInfo = JSON.parse(userData)
         console.log('coddd',userInfo);
       this.userCountry = userInfo.country;
       this.isB2B = userInfo.isb2b;
       this.isquick = userInfo.is_qwik_user,
       this.issuperadmin = userInfo.is_superadmin
       console.log("Countryyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyy",this.userCountry);
       Vue.http.headers.common['country'] =userInfo.country;

 
        this.adminuser=userInfo.userfirstname+' '+userInfo.userlastname;
          
          
        this.id = userInfo.sysusermasterid;
      } 
      else {
        this.$router.push('login')
      }
    },

    goToB2BDashboard: function(event){
      if(window.location.origin=='http://localhost:8080'){
       
        const data = {}
        data.userData = localStorage.getItem('userData');
        data.country = localStorage.getItem('country');
        const win = window.open(`http://localhost:8081/b2b_cms/dashboard_b2b?isFromLocalhost=true`, '_blank');

        window.addEventListener('message', function handshakeListener(event) {
          if (event.origin !== 'http://localhost:8081') {
            console.log('event origin wrong!!!!')
            return;
          }
          if (event.data === 'ready') {
            console.log('event data ready---->')
            win.postMessage(data, 'http://localhost:8081');
            window.removeEventListener('message', handshakeListener);
          }
        });

      }else{
        window.open(`${window.location.origin}/b2b_cms/dashboard_b2b`,'_blank')
      }
    },
    
    goToQuickDashboard(){
        // this.$router.push('/dashboard_adv_quick/quick_dashboard');
        const url = `${window.location.origin}/dashboard_adv_quick/quick_dashboard`
     
        if (this.isQuickDashboard) {
          window.location.href = url
        } else {
           window.location.href = url
        }
    },

    goTop2pDashboard() {

      const url = `${window.location.origin}/dashboard_adv`

      // if currently on quick dashboard -> open in same tab
      if (this.isQuickDashboard) {
        window.location.href = url
      } else {
        window.location.href = url
      }
    }
  }
};
</script>

<style>

#overlay {
  position: fixed; /* Sit on top of the page content */
  /*display: none;*/ /* Hidden by default */
  width: 100%; /* Full width (cover the whole page) */
  height: 100%; /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0.5); /* Black background with opacity */
  z-index: 9999; /* Specify a stack order in case you're using a different order for other elements */
  cursor: pointer; /* Add a pointer on hover */
}
  .loader {
  position: fixed;;
  border: 5px solid #f3f3f3;
  border-radius: 50%;
  border-top: 5px solid #3498db;
  width: 50px;
  height: 50px;
  left:50%;
  top:50%;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
 
} 
#modeloverlay {
  position: fixed; /* Sit on top of the page content */
  /*display: none;*/ /* Hidden by default */
  width: 100%; /* Full width (cover the whole page) */
  height: 100%; /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0.5); /* Black background with opacity */
  z-index: 9999; /* Specify a stack order in case you're using a different order for other elements */
  cursor: pointer; /* Add a pointer on hover */
}
  .modelloader {
  position: fixed;;
  border: 5px solid #f3f3f3;
  border-radius: 50%;
  border-top: 5px solid #3498db;
  width: 50px;
  height: 50px;
  left:50%;
  top:50%;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
 
} 
.loading{
   position: relative;
 
  width: 50px;
  height: 50px;
  left:50%;
  top:56%;
}

.v-sidebar-menu ,.vsm--scroll-wrapper{
  /* background-color: #00c0ef !important; */
  max-width: 100% !important;
  border-width: 0px !important;
  overflow-y: auto;
    overflow-x: hidden;
  left: 0 !important;
  position: absolute !important;
  height: 100%;
  top:0px !important;
  right: 0 !important;
  padding-left: 0px;
  
}
.sidebar-lg-show .v-sidebar-menu {
    position: fixed !important;
    width: 211px !important;
}

.header-fixed{
    width: 98%;
}
.sidebar-lg-show .app-header {
    width: 85%!important;
    z-index: 1;
}

.app-header {
    width: 101%!important; 
    justify-content: center; 
    align-items: center;  
}

/* .app-header .navbar-brand{
    margin-left: 30rem;
}

.sidebar-lg-show .app-header .navbar-brand{
    margin-left: 23rem;
} */

.app-header .navbar-brand {
    position: absolute;
    left: 50%;
    transform: translateX(-50%); 
}


.breadcrumb {
  margin-bottom: 0rem;
  height: 50px !important;
}

@media (max-width: 992px) { 
    .app-header {
        width: 100% !important; 
        left: 0;
        right: 0;
        z-index: 999; 
    }

    .app-body {
        padding-top: 50px; 
        margin-top: 0px !important;
    }


    .sidebar-lg-show .app-header {
        width: 100% !important; 
    }
}

/* table related styles */
.table.b-table.b-table-stacked-md > tbody > tr > [data-label]::before{
  float: none!important;
}

.table thead, .table thead tr {
    background: #ECEFF1 !important;
    word-wrap: break-word;
}
 .table thead, .table thead tr:hover {
    background: #ECEFF1 !important;
}
.table th, .table td {
    padding: .5rem!important;
    vertical-align: top!important;
}
.table {
    width: 100%;
    margin-bottom: 1rem;
    background-color: transparent;
}

.card{
      word-wrap: break-word!important;
}

.table-striped tbody tr:nth-of-type(odd) {
     background-color: #fff !important;
}

.table.b-table > thead > tr > th[aria-sort][aria-sort="ascending"]::after, .table.b-table > tfoot > tr > th[aria-sort][aria-sort="ascending"]::after, 
.table.b-table > thead > tr > th[aria-sort][aria-sort="descending"]::after, .table.b-table > tfoot > tr > th[aria-sort][aria-sort="descending"]::after,
.table.b-table > thead > tr > th[aria-sort]::after, .table.b-table > tfoot > tr > th[aria-sort]::after{
  font-size: 25px;
  padding-bottom: 0 !important;
}

.table tr th {
  color: #333 !important;
}

.main .container-fluid {
    padding: 0 0px!important;
}
.wing{
  width: 20%
}




</style>
